'use client';
import { Container } from '@/components/container';
import { Button } from '@/components/ui/button';
import { useAuthStore } from '@/store';
import Link from 'next/link';
import React from 'react';

export const MembershipBanner = () => {
  const user = useAuthStore((state) => state.user);

  if (user) {
    return null;
  }

  return (
    <div className="bg-ihs-gray grid place-items-center">
      <Container>
        <div className="py-8 flex flex-col gap-8">
          <div className="flex xl:flex-row flex-col gap-8">
            <div className="xl:max-w-[220px] text-center xl:text-left flex flex-col gap-4">
              <div className="font-bold text-3xl tracking-tight">
                Membership Benefits
              </div>
              <p className="text-sm">
                Unlock exclusive content and features by becoming a member
              </p>
            </div>

            <div className="flex-1 flex md:flex-row gap-4 xl:gap-0 flex-col items-center">
              <div className="bg-ihs-blue rounded-3xl gap-8 flex justify-center flex-col xl:w-[434px] xl:h-[600px] w-full h-[400px] text-white p-12">
                <div className="font-bold text-2xl">
                  Registered User Features
                </div>

                <ol type="1" className="list-decimal list-inside space-y-2">
                  <li>Full access to all platform content</li>
                  <li>
                    Engage fully—ask questions, share stories, and comment
                  </li>
                  <li>Personalized feed based on selected interests</li>
                </ol>

                <Button
                  variant="outline"
                  className="bg-white text-ihs-blue hover:bg-gray-100 hover:text-ihs-blue transition ease-in-out py-6"
                >
                  <Link href="/sign-up" className="w-full">
                    Sign up as Registered User
                  </Link>
                </Button>
              </div>

              <div className="rounded-3xl xl:rounded-l-none border-black flex gap-8 justify-center flex-col border h-[400px] xl:h-[540px] xl:border-l-0 w-full xl:w-[404px] p-12">
                <div className="font-bold text-2xl">Guest User Features</div>

                <ol type="1" className="list-decimal list-inside space-y-2">
                  <li>Limited access to content</li>
                  <li>Restricted interaction with platform content</li>
                  <li>Can view only spotlight questions</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
